"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateBankAccountSchema = void 0;
const yup = __importStar(require("yup"));
const ACCOUNT_NUMBER_MIN = "Account number should be at least 6 digits";
const ACCOUNT_NUMBER_MAX = "Account number can not exceed 12 digits";
const ACCOUNT_BSB_MANDATORY = "Please enter a BSB";
const ACCOUNT_NAME_MANDATORY = "Please enter an account name";
const ACCOUNT_NUMBER_MANDATORY = "Please enter an account number";
exports.CreateBankAccountSchema = yup.object().shape({
    accountName: yup
        .string()
        .trim(ACCOUNT_NAME_MANDATORY)
        .required(ACCOUNT_NAME_MANDATORY)
        .min(2, "Account name should be at least 2 characters")
        .max(60),
    accountBSB: yup
        .string()
        .trim(ACCOUNT_BSB_MANDATORY)
        .required(ACCOUNT_BSB_MANDATORY)
        .test("must be 6 digits", "BSB must be exactly 6 digits", (accountBSB) => accountBSB.replace(/ /g, "").length === 6)
        .matches(/^[0-9 ]+$/, "BSB should contain only digits"),
    accountNumber: yup
        .string()
        .trim(ACCOUNT_NUMBER_MANDATORY)
        .required(ACCOUNT_NUMBER_MANDATORY)
        .test("minimum 6 digits", ACCOUNT_NUMBER_MIN, (accountNumber) => accountNumber.replace(/ /g, "").length > 5)
        .test("maximum 12 digits", ACCOUNT_NUMBER_MAX, (accountNumber) => accountNumber.replace(/ /g, "").length < 13)
        .matches(/^[0-9 ]+$/, "Account number should contain only digits"),
});
//# sourceMappingURL=CreateBankAccountSchema.js.map